import { E_HEADER_TYPE } from '@/domains/header/enums';
import { injectService } from '@/inversify.config';
import { HeaderServiceManager } from '@/domains/header/header-service';
import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';
import { useUserInfo } from './user/use-user-info';
export const useHeader = createSharedComposable(() => {
    const { updateUserInfoFromHeader, isFree } = useUserInfo();
    const headerServiceManager = injectService(HeaderServiceManager);
    const headerService = ref(headerServiceManager.getHeaderServiceInstance());
    const initHeaderData = () => {
        return headerServiceManager.syncHeaderAccountInfo().then((accountInfo) => {
            updateUserInfoFromHeader(accountInfo);
            headerServiceManager.setLocale();
        });
    };
    const logout = () => {
        headerService.value.userCenterService.logout();
    };
    const resetHeaderData = (type) => {
        if (isFree.value && type === E_HEADER_TYPE.DETAIL_VIEW) {
            type = E_HEADER_TYPE.FREE_DETAIL_VIEW;
        }
        headerService.value = headerServiceManager.resetHeaderData(type);
    };
    // initHeaderData()
    return {
        headerService,
        logout,
        resetHeaderData,
        initHeaderData,
    };
});
